<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      <div class="row">
        <div class="col-sm-10">
          Quotes
        </div>
        <div class="col-sm-2">
          <button mat-raised-button color="'primary'" type="button" class="fmc-button-primary" (click)="createQuote()">Create New Quote</button>
        </div>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-12">
        <ng-container>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let quote of quotesFormArray.controls; index as i" [hideToggle]="true">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  <strong>{{ quote.value.borrower }}</strong>, Created {{ quote.value.createdDate | date: 'longDate' }}
                </mat-panel-title>
                <mat-panel-description style="flex: 0 0 auto;">
                  <button mat-icon-button type="button" (click)="viewQuote(i)">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-icon-button type="button" color="primary" (click)="redirectWizard(i)" class="fmc-button-primary">
                    <mat-icon>check_circle_outline</mat-icon>
                  </button>
                  <button mat-icon-button type="button" color="warn" (click)="deleteQuote(i)">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </mat-panel-description>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-4 offset-sm-10">
        <button mat-raised-button type="button" color="primary" (click)="loadPrev()" [disabled]="pageIndex === 0">
          Prev
        </button>
        <button mat-raised-button type="button" color="primary" class="fmc-button-primary" (click)="loadNext()" [disabled]="disableNext">
          Next
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
